import { render } from "./ReportForm.vue?vue&type=template&id=01579798"
import script from "./ReportForm.vue?vue&type=script&lang=js"
export * from "./ReportForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__